module.exports = __webpack_public_path__ + "fonts/group_42970_1_1.svg";